import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewWinManga = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'winmanga',
        name: 'winmanga',
        component: ViewWinManga,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
